export default {"src":"/_next/static/media/wall-of-love.161402d1.svg","height":1857,"width":1064,"blurWidth":0,"blurHeight":0};